import { IFAQModel } from '../../interfaces/models/faqs.interfaces'
import { sortStringsAlphabetically } from '../../helpers/sorting'

export interface FaqSectionModel extends IFAQModel {
  questions?: IFAQModel[]
}

const FAQ_SORT_LOCALE = 'sv'

const sortFaqStrings = (a?: string, b?: string): number =>
  sortStringsAlphabetically(a, b, false, FAQ_SORT_LOCALE)

export const separateSectionsAndQuestions = (
  data: IFAQModel[]
): FaqSectionModel[] => {
  const rootSections = new Map<string, IFAQModel>()
  data.forEach((item) => {
    const existing = rootSections.get(item.section)
    if (!existing || (!item.question && existing.question)) {
      rootSections.set(item.section, item)
    }
  })
  const uniqueRootSections = [...rootSections.values()]

  // A document without a question is the section itself, not a question
  const questions = data.filter((item) => !!item.question)
  questions.sort((a, b) => sortFaqStrings(a.question, b.question))

  const processedSections = uniqueRootSections.reduce(
    (prev: FaqSectionModel[], curr) => {
      const section = {
        ...curr,
        questions: questions.filter(
          (question) => question.section === curr.section
        ),
      }
      prev.push(section)
      return prev
    },
    []
  )

  return processedSections.sort((a, b) => sortFaqStrings(a.section, b.section))
}
